const SvgCross = () => (
	<svg width="1em" height="1em" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13.595 1.5 2 13.5M2 1.5l11.595 12"
			stroke="currentColor"
			strokeWidth={2}
			strokeLinecap="square"
			strokeLinejoin="round"
		/>
	</svg>
)

export default SvgCross
